import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from '../../common/withRouter';
import {
  Loader,
  ButtonOBSOLETED,
  Notification,
  Message,
} from "../../web.common";
import { LayoutContext } from "../layout/siteLayout";
import PageTop from "../layout/PageTop";
import withApi from "../higherOrderComponents/withApi";
import {
  Filters,
  FilterInput,
  FilterSelect,
  FilterSelectAsync,
  FilterTimePicker,
  FilterCheckBox,
} from "./Filters";
import { getQueryStringParameters } from "../../common/utils";
import { DisplayDate, DisplayGuid, DisplayType } from "../items";
import AriaModal from 'react-aria-modal';

const SignupsInternal = (props) => {
  const [loadedData, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [modalContent, setModalContent] = useState(false);

  const navigationButtonStyle = {
    width: "6%",
    color: "grey",
    fontSize: "0.85rem",
  };

  const clickable ={
    cursor: "pointer"
  }

  useEffect(() => {
    async function loadFromApi() {      
      loadData();
    }
    if (!loadedData) {
      loadFromApi();
    }
  });

  const loadData = async () => {
    setIsLoading(false);
    const { history, location } = props;
    const filters = getQueryStringParameters(location.search);
    const data = await props.api.signups.searchSignups({
      filters
    });
    setData(data);

    setIsLoading(true);
  };

  const lookupFacility = async (inputValue) => {
      const response = await props.api.facilities.lookupByNameOrId(inputValue);
      return response;
  };

  const { categories } = props;
  const mappedCategories = categories.map(({ Name }) => ({
    value: Name,
    label: Name,
  }));

  const mappedSignupStatus = [
    {value: 'Undefined', label: 'Undefined'},
    {value: 'Booked', label: 'Booked'},
    {value: 'Cancelled', label: 'Cancelled'}
  ];

  const filters = getQueryStringParameters(location.search);
  const page = parseInt(filters.page) || 1;
  const orderBy = filters.orderBy || "signupdate";
  const orderDirection = filters.orderDirection || "desc";
  
  const orderHandler = (name) => {
    const { history, location } = props;
    let direction;
    let orderName;
    if (name.toLowerCase().includes("activitydate")) {
      orderName = "activitydate";
    } else if (name.toLowerCase().includes("signupdate")) {
      orderName = "signupdate";
    } else {
      orderName = name;
    }

    if (orderName.toLowerCase() === orderBy.toLowerCase()) {
      direction = orderDirection === "desc" ? "asc" : "desc";
    } else {
      direction = "desc";
    }
 
    Filters.goToPage(history, location, page, orderName, direction);
  }

  const pagingHandler = async (action) => {
    const { history, location } = props;
    
      if (page < loadedData.pages && action === "add") {
        Filters.goToPage(history, location, page + 1, orderBy, orderDirection);
      }
      if(page > 1 && action === "sub"){
        Filters.goToPage(history, location, page - 1, orderBy, orderDirection);
      }
  }

  const openModal = (comment, credentials) => {
    setModalContent(
        <AriaModal
          titleText='Show comments and credentials'
          mounted
          verticallyCenter={false}
          focusDialog
          getApplicationNode={() => document.getElementById('app')}
          dialogClass='dialog-size-normal'
        >
          <div>
            <p>
              {comment != null && comment.split('\n').map((line, index) => <span key={index}>{line}<br /></span>)}
            </p>
            <p>
              {credentials != null && credentials.split('\n').map((line, index) => <span key={index}>{line}<br /></span>)}
            </p>
          </div>
         
          <ButtonOBSOLETED
            buttonColor='gray'
            size='small'
            onClick={() => {setModalContent(false)}}
            disabled={false}
            buttonContent='Back'
            ariaLabel='return'
          >
            Back
          </ButtonOBSOLETED>
        </AriaModal>
      
    )
  }

  const header = [
    {
      name: "Id",
      label: "Id",
      canOrder: false,
      breakWord: false,
      render: ({ id }) => <DisplayGuid baseAnchor={'signup'}>{id}</DisplayGuid>,
    },
    {
      name: "Facility",
      label: "Facility",
      canOrder: true,
      breakWord: false,
      render: ({  facilityName }) => <span>{facilityName}</span>,
    },
    {
      name: "Category",
      label: "Category",
      canOrder: true,
      breakWord: false,
      render: ({ category }) => <span>{category}</span>,
    },
    {
      name: "CourtName",
      label: "CourtName",
      canOrder: true,
      breakWord: false,
      render: ({ courtName }) => <span>{courtName}</span>,
    },
    {
      name: "Duration",
      label: "Duration",
      breakWord: false,
      render: ({ duration }) => <span>{duration}</span>,
    },
    {
      name: "User",
      label: "User",
      sortBy: "username",
      canOrder: true,
      breakWord: false,
      render: ({ userId, userName, userEmail, userPhoneNumber }) => {
        const atIndex = userEmail ? userEmail.indexOf("@") : -1;
        return (
          <span style={{
            display: "inline-flex",
            flexDirection: "column",
            gap: "0.25rem",
            maxWidth: "20ch",
            overflowWrap: "break-word",
          }}>
            <span>{userName}</span>
            {userPhoneNumber && <span>({userPhoneNumber})</span>}
            <span>
              {atIndex === -1 ? (
                userEmail
              ) : (
                <>
                  {userEmail.slice(0, atIndex + 1)}
                  <wbr />
                  {userEmail.slice(atIndex + 1)}
                </>
              )}
            </span>
            <DisplayGuid baseAnchor={"user"} short>{userId}</DisplayGuid>
          </span>
        );
      },
    },
    {
      name: "SignupDateCet",
      label: "SignupDate (CET)",
      canOrder: true,
      breakWord: false,
      render: ({ signupDateCet }) => (
        <DisplayDate breakTime>{signupDateCet}</DisplayDate>
      ),
    },
    {
      name: "ActivityDateCet",
      label: "ActivityDate (CET)",
      canOrder: true,
      breakWord: false,
      render: ({ activityDateCet }) => (
        <DisplayDate breakTime>{activityDateCet}</DisplayDate>
      ),
    },
    {
      name: "Status",
      label: "Status",
      canOrder: true,
      breakWord: false,
      render: ({ status }) => <span>{camelToWords(status)}</span>,
    },
    {
      name: "IsBundle",
      label: "IsBundle",
      canOrder: false,
      breakWord: false,
      render: ({ isBundle }) => <span>{isBundle === true ? "true" : "false"}</span>,
    },
    {
      name: "SecretCode",
      label: "Secret",
      canOrder: false,
      breakWord: false,
      render: ({ secretCode }) => <span>{secretCode}</span>,
    },
    {
      name: "Confirmations",
      label: "Confirmations",
      canOrder: false,
      breakWord: false,
      render: ({ confirmations }) => {
        const confirmationList = confirmations.split(",");
        return confirmationList.map((x) => (
          <>
            <DisplayGuid baseAnchor={"email"} short>
              {x}
            </DisplayGuid>{" "}
          </>
        ));
      },
    },
    {
      name: "Actions",
      label: "Actions",
      render: ({ comment, credentials, id }, isSignup) => (
        <span>
          {/* <button onClick={async () => await props.api.overview.retry(id)}>
            retry
          </button>
          /* <button onClick={async () => await props.api.overview.mute(id, isSignup)}>
            mute
          </button>
          <br />
          <button
            onClick={async () => await props.api.overview.sendConfirmation(id, isSignup)}
          >
            confirm
          </button> */}
          <button onClick={() => 
                openModal(comment,credentials)
          }>
            help
          </button>
        </span>
      ),
    },
  ];

  return (
    <LayoutContext.Consumer>
      {() => (
        <React.Fragment>
          {/* <Notification newMessage={errorMessage} /> */}
          {modalContent}
          <div className="content-with-right-pane-delimiter">
            <PageTop
              documentTitle="Signup list"
              documentDescription="Signup list"
            />
            <h2 className="main-page-header">Signups</h2>
            <Filters
              initFromUrl
              submitUrl
              validateForm={(
                {
                  id,
                  facilityId,
                  user,
                  secretCode,
                  category,
                  activityFrom,
                  activityTo,
                  signupFrom,
                  signupTo,
                  status,
                  externalReference,
                  resultsPerPage,
                  courtName,
                  purchaseId,
                  onlyBundles
                },
                updatedKey
              ) => {
                if (updatedKey !== "id") {
                  return {
                    id,
                    facilityId,
                    user,
                    secretCode,
                    category,
                    activityFrom,
                    activityTo,
                    signupFrom,
                    signupTo,
                    status,
                    externalReference,
                    resultsPerPage,
                    courtName,
                    purchaseId,
                    onlyBundles
                  };
                }
                return { id };
              }}
              render={(formData, update) => (
                <div className="filters-block">
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="id">
                      Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name="id"
                      placeholder="Find by id"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="facilityId">
                      Facility
                    </label>
                    <FilterSelectAsync
                      className='filter-select'
                      data={formData}
                      debounce
                      update={update}
                      name='facilityId'
                      loadOptions={async (inputValue) => lookupFacility(inputValue)}
                    />
                    {/* <FilterInput
                      data={formData}
                      update={update}
                      name="facilityId"
                      placeholder="Find by facility id"
                    /> */}
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="user">
                      User
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name="user"
                      placeholder="Filter by user"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="courtName">
                      Court Name
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name="courtName"
                      placeholder="Filter by court name"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="secretCode">
                      Secret Code
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name="secretCode"
                      placeholder="Filter by secret code"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label
                      className="filters-label"
                      htmlFor="externalReference"
                    >
                      External Reference
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name="externalReference"
                      placeholder="Filter by external reference"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="signupFrom">
                      Signup From
                    </label>
                    <FilterTimePicker
                      className="filter-date-picker"
                      data={formData}
                      update={update}
                      name="signupFrom"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="signupTo">
                      Signup To
                    </label>
                    <FilterTimePicker
                      data={formData}
                      update={update}
                      name="signupTo"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="activityFrom">
                      Activity From
                    </label>
                    <FilterTimePicker
                      className="filter-date-picker"
                      data={formData}
                      update={update}
                      name="activityFrom"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="activityTo">
                      Activity To
                    </label>
                    <FilterTimePicker
                      data={formData}
                      update={update}
                      name="activityTo"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="category">
                      Category
                    </label>
                    <FilterSelect
                      className="filter-select"
                      data={formData}
                      update={update}
                      name="category"
                      options={mappedCategories}
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="status">
                      Status
                    </label>
                    <FilterSelect
                      className="filter-select"
                      data={formData}
                      update={update}
                      name="status"
                      options={mappedSignupStatus}
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="resultsPerPage">
                      Results Per Page
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name="resultsPerPage"
                      placeholder="insert number of result to show per page"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="resultsPerPage">
                      PurchaseId
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name="purchaseId"
                      placeholder="insert purchase id"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="onlyBundles">
                      Only bundles
                    </label>
                    <FilterCheckBox
                      data={formData}
                      update={update}
                      name="onlyBundles"
                    />
                  </div>
                  <br />
                  <br />
                  <div className="filters-submit-wrapper">
                    <ButtonOBSOLETED
                      type="submit"
                      buttonContent="Search"
                      disabled={!isLoading}
                    />
                  </div>
                  <hr />
                </div>
              )}
            />
            {loadedData == null ? (
              <span>Loading...</span>
            ) : (
              <>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <input
                    style={navigationButtonStyle}
                    type="button"
                    value="< Prev"
                    onClick={() => pagingHandler("sub")}
                  />
                  <span style={{ color: "grey", fontSize: "0.85rem" }}>
                    Showing page {page} out of {loadedData.pages}
                  </span>
                  <input
                    style={navigationButtonStyle}
                    type="button"
                    value="Next >"
                    onClick={() => pagingHandler("add")}
                  />
                </div>
                <br />
                <article className="data-table-wrap">
                  <table className="data-lists component-data-table cell-content-align-top">
                    <thead>
                      <tr>
                        {header.map((property) => (
                          <td
                            style={property.canOrder ? clickable : null}
                            onClick={() =>
                              typeof property === "object" && property.canOrder
                                ? orderHandler(property.sortBy || property.label)
                                : property
                            }
                          >
                            {typeof property === "object"
                              ? property.label
                              : property}{" "}
                            {(property.sortBy || property.label).toLowerCase().includes(orderBy.toLowerCase())
                              ? orderDirection === "desc"
                                ? "↓"
                                : "↑"
                              : ""}
                          </td>
                        ))}
                      </tr>
                    </thead>
                    {loadedData.signups.map((row) => (
                      <tbody>
                        <tr className="hover-listview ">
                          {header.map((property) => (
                            <td style={ property.breakWord ? {overflowWrap: 'anywhere'} : {}}>
                              <strong className="table-cell-label">
                                {typeof property === "object"
                                  ? property.label
                                  : property}
                              </strong>
                              {typeof property === "object" ? (
                                property.render(row)
                              ) : property === "Status" ? (
                                <span>{camelToWords(row[property])}</span>
                              ) : (
                                <span>{row[property]}</span>
                              )}
                            </td>
                          ))}
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </article>
              </>
            )}
          </div>
        </React.Fragment>
      )}
    </LayoutContext.Consumer>
  );
};

function camelToWords(text) {
  if (text == null || text == undefined) {
    text = "null";
  }
  const result = text.replace(/([A-Z])/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1);
}

const Signups = withRouter(
  withApi(
    connect(
      ({ user, categories }) => ({ isLoggedIn: !!user, categories }),
      {}
    )(SignupsInternal)
  )
);

Signups.requiresLogin = true;
Signups.propTypes = { isLoggedIn: PropTypes.bool };

export default Signups;
